import React from 'react';

const StatusBadge = ({ status }) => {
    const numericStatus = parseFloat(status); // ✅ `status` を数値に変換

    let label = '未設定';
    let className = 'status-badge default';

    switch (numericStatus) {  // ✅ `parseFloat(status)` を適用
        case 1.0:
            label = '未着手';
            className = 'status-badge not-started';
            break;
        case 3.0:
            label = 'ヒアリング中';
            className = 'status-badge hearing';
            break;
        case 5.0:
            label = '企画書作成中';
            className = 'status-badge planning';
            break;
        case 7.0:
            label = '運用準備中';
            className = 'status-badge preparation';
            break;
        case 9.0:
            label = '運用中';
            className = 'status-badge in-progress';
            break;
        default:
            label = '不明';
            className = 'status-badge unknown';
    }

    return <span className={className}>{label}</span>;
};

export default StatusBadge; // ✅ `export default` でエクスポート
